// src/components/organisms/PatientWorkspaceTabs/deviceMeta.js
//
// Cihaz ölçümü yardımcıları (DeviceMeasurementsTab).

export function formatDateTime(d) {
  return new Date(d).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
